import { useEffect } from 'react';

/**
 * Runs an effect exactly once on mount. Sanctioned escape hatch for mount-only
 * side-effects; callers must NOT close over reactive values they expect to track.
 */
// eslint-disable-next-line react-hooks/exhaustive-deps
const useMountEffect = effect => useEffect(effect, []);

export default useMountEffect;
